// extracted by mini-css-extract-plugin
export var chevronIcon = "_te-1";
export var edgeToggle = "_te-0";